import React from 'react';

export default function BirthdaySection() {
  return (
    <section id="birthday" style={{
      padding: 'clamp(60px, 10vw, 120px) 24px',
      background: 'linear-gradient(180deg, #120a1f 0%, #0d0a14 100%)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Confetti-like dots */}
      <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
        {['🎉','🎊','✨','🌟','💫','🎈','🎁','🎂'].map((e, i) => (
          <div key={i} style={{
            position: 'absolute',
            fontSize: `${14 + (i % 3) * 4}px`,
            opacity: 0.15,
            top: `${5 + i * 11}%`,
            left: i % 2 === 0 ? `${3 + i * 5}%` : undefined,
            right: i % 2 !== 0 ? `${3 + i * 4}%` : undefined,
            animation: `float ${3 + i * 0.5}s ease-in-out infinite`,
            animationDelay: `${i * 0.4}s`,
          }}>{e}</div>
        ))}
      </div>

      <div style={{ maxWidth: 900, margin: '0 auto', textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <div className="section-badge" style={{ margin: '0 auto 20px', display: 'inline-flex', borderColor: 'rgba(56,189,248,0.3)', background: 'rgba(56,189,248,0.08)' }}>
          <span>🎂</span> Chapter 6
        </div>
        <h2 style={{
          fontFamily: 'Poppins, sans-serif', fontWeight: 800,
          fontSize: 'clamp(32px, 6vw, 58px)', lineHeight: 1.15, marginBottom: 8,
        }}>
          Fiza's <span style={{
            background: 'linear-gradient(135deg, #38bdf8, #a855f7, #ff6b9d)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>Birthday</span> 🎂
        </h2>
        <div className="section-divider center" style={{ background: 'linear-gradient(90deg, #38bdf8, #a855f7)' }} />
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          padding: '8px 18px',
          background: 'rgba(56,189,248,0.08)',
          border: '1px solid rgba(56,189,248,0.2)',
          borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 14,
          color: '#38bdf8', marginBottom: 48,
        }}>
          🎂 14 October 2025
        </div>

        {/* Birthday Illustration */}
        <div style={{ margin: '0 auto 48px', animation: 'float 4s ease-in-out infinite' }}>
          <svg viewBox="0 0 340 260" xmlns="http://www.w3.org/2000/svg" style={{ width: '100%', maxWidth: 340, margin: '0 auto', display: 'block' }}>
            <defs>
              <linearGradient id="cakeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#ff6b9d" />
                <stop offset="100%" stopColor="#a855f7" />
              </linearGradient>
              <linearGradient id="cakeLayer2" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#a855f7" />
                <stop offset="100%" stopColor="#38bdf8" />
              </linearGradient>
            </defs>

            {/* Balloons */}
            <ellipse cx="60" cy="60" rx="22" ry="28" fill="#ff6b9d" opacity="0.8" />
            <line x1="60" y1="88" x2="60" y2="150" stroke="#ff6b9d" strokeWidth="1.5" />
            <ellipse cx="280" cy="55" rx="22" ry="28" fill="#a855f7" opacity="0.8" />
            <line x1="280" y1="83" x2="280" y2="150" stroke="#a855f7" strokeWidth="1.5" />
            <ellipse cx="40" cy="90" rx="18" ry="24" fill="#38bdf8" opacity="0.7" />
            <line x1="40" y1="114" x2="55" y2="155" stroke="#38bdf8" strokeWidth="1.5" />
            <ellipse cx="300" cy="85" rx="18" ry="24" fill="#fb923c" opacity="0.7" />
            <line x1="300" y1="109" x2="285" y2="155" stroke="#fb923c" strokeWidth="1.5" />

            {/* Cake base - tier 3 */}
            <rect x="80" y="190" width="180" height="50" rx="10" fill="#2d1f4a" />
            <rect x="80" y="190" width="180" height="18" rx="10" fill="url(#cakeGrad)" opacity="0.8" />
            {/* Cake decorations tier 3 */}
            {[95,120,145,170,195,220,240].map(x => (
              <circle key={x} cx={x} cy="200" r="4" fill="white" opacity="0.6" />
            ))}

            {/* Cake tier 2 */}
            <rect x="100" y="155" width="140" height="40" rx="8" fill="#2d1f4a" />
            <rect x="100" y="155" width="140" height="16" rx="8" fill="url(#cakeLayer2)" opacity="0.8" />
            {[115,140,165,190,215].map(x => (
              <circle key={x} cx={x} cy="163" r="3" fill="white" opacity="0.6" />
            ))}

            {/* Cake top tier */}
            <rect x="120" y="125" width="100" height="35" rx="8" fill="#2d1f4a" />
            <rect x="120" y="125" width="100" height="14" rx="8" fill="url(#cakeGrad)" opacity="0.7" />

            {/* Frosting drips */}
            {[130,150,170,190,205].map((x, i) => (
              <path key={x} d={`M${x},125 Q${x+3},118 ${x+6},125`} fill="white" opacity="0.5" />
            ))}

            {/* Candles */}
            {[140,157,174,191].map((x, i) => (
              <g key={x}>
                <rect x={x - 3} y={105} width={6} height={20} rx="3"
                  fill={['#ff6b9d','#a855f7','#38bdf8','#fb923c'][i]} />
                {/* Flame */}
                <ellipse cx={x} cy={100} rx={4} ry={6} fill="#ffd700" />
                <ellipse cx={x} cy={102} rx={2.5} ry={4} fill="#fb923c" />
              </g>
            ))}

            {/* F & H letters on cake */}
            <text x="158" y="148" textAnchor="middle" fill="white" fontSize="14" fontFamily="Poppins, sans-serif" fontWeight="bold">F & H</text>

            {/* Stars */}
            <text x="100" y="50" fontSize="16">⭐</text>
            <text x="230" y="45" fontSize="14">✨</text>
            <text x="165" y="30" fontSize="20">🎉</text>
          </svg>
        </div>

        {/* Birthday wish card */}
        <div style={{
          maxWidth: 660, margin: '0 auto',
          background: 'linear-gradient(135deg, rgba(56,189,248,0.06), rgba(168,85,247,0.06), rgba(255,107,157,0.06))',
          border: '1px solid rgba(56,189,248,0.2)',
          borderRadius: 28, padding: '48px 40px',
          position: 'relative', overflow: 'hidden',
        }}>
          <div style={{
            position: 'absolute', top: 0, left: 0, right: 0, height: 3,
            background: 'linear-gradient(90deg, #38bdf8, #a855f7, #ff6b9d)',
          }} />
          <div style={{ fontSize: 48, marginBottom: 20 }}>🎂</div>
          <h3 style={{
            fontFamily: 'Poppins, sans-serif', fontWeight: 700, fontSize: 24,
            marginBottom: 20,
            background: 'linear-gradient(135deg, #38bdf8, #a855f7, #ff6b9d)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>
            Happy Birthday, Fiza! 🎉
          </h3>
          <p style={{
            fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
            color: '#e2c8d8', marginBottom: 20,
          }}>
            On this beautiful day, 14th October 2025, Hassan wished the most special person the happiest birthday. You bring light to every dark corner, laughter to every silent moment, and joy to every single day. 🌟
          </p>
          <p style={{
            fontFamily: 'Nunito, sans-serif', fontSize: 16, lineHeight: 1.9,
            color: '#9b7ba8', marginBottom: 28,
          }}>
            May every wish you make come true, may every dream you hold become your reality, and may this year bring you all the happiness you deserve — and more. Happy birthday, jaan! 💕✨
          </p>

          <div style={{
            display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap',
          }}>
            {['🎂 Cake & Celebrations', '🌹 Hassan Ka Pyar', '✨ All Your Dreams', '🦋 New Adventures'].map(t => (
              <span key={t} style={{
                padding: '8px 16px',
                background: 'rgba(56,189,248,0.08)',
                border: '1px solid rgba(56,189,248,0.15)',
                borderRadius: 50, fontFamily: 'Nunito, sans-serif', fontSize: 13,
                color: '#38bdf8',
              }}>{t}</span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}